(() => {
    const SELECTORS = {
        host: "[data-availability-form] #app-embed",
        product_id: "[data-availability-form-product-id]",
        language_input: "custom#language",
        product_input: "custom#product",
    };

    function getCurrentLanguage() {
        return document.documentElement.getAttribute('lang')
        // const candidates = [
        //     document.documentElement.getAttribute('lang'),
        //     navigator.language,
        //     navigator.userLanguage
        // ];

        // for (let i = 0; i < candidates.length; i++) {
        //     const lang = (candidates[i] || '').toLowerCase();

        //     if (lang.startsWith('it')) return 'it';
        //     if (lang.startsWith('ro')) return 'ro';
        //     if (lang.startsWith('en')) return 'en';
        // }

        // return 'en';
    }

    function setFieldValue(el, value) {
        el.value = value;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function hideField(el) {
        const wrapper =
            el.closest('[data-field]') ||
            el.closest('.field') ||
            el.closest('div');

        if (wrapper) {
            wrapper.style.display = 'none';
        } else {
            el.style.display = 'none';
        }
    }

    function setLanguageField(root) {
        const languageField = root.getElementById(SELECTORS.language_input);

        if (!languageField) return;

        setFieldValue(languageField, getCurrentLanguage());
        hideField(languageField);
    }

    function setProductField(root, host) {
        const productField = root.getElementById(SELECTORS.product_input);
        const form = document.querySelector('[data-availability-form]');
        const productId = form.dataset.availabilityFormProductId;

        if (!productField) return;

        setFieldValue(productField,  productId);
        hideField(productField);
    }

    function styleUI(root) {
        const h2 = root.querySelector('h2');
        const header = h2?.closest('section');
 
            h2.style.margin = '10px 0'; 

        const submitBtn = root.querySelector('button[type="submit"]');

        if (submitBtn) {
            submitBtn.style.fontSize = '18px';
        }

        const disclaimer = root.querySelector('._formDisclaimer_jnbzb_38 p');

        if (disclaimer) {
            disclaimer.style.fontSize = '14px';
            disclaimer.style.textAlign = 'center';
            disclaimer.style.lineHeight = '140%';
            disclaimer.style.color = '#5A5A5A';
        }
    }

    function tryInit() {
        const host = document.querySelector(SELECTORS.host);

        if (!host) return false;

        const root = host.shadowRoot;

        if (!root) return false;

        setLanguageField(root);
        setProductField(root, host);
        styleUI(root);

        return true;
    }

    function waitUntilReady(maxWaitMs) {
        const start = Date.now();

        const interval = setInterval(() => {
            if (tryInit() || Date.now() - start > maxWaitMs) {
                clearInterval(interval);
            }
        }, 200);
    }

    waitUntilReady(5000);
})();